import {
  IEditingUser,
  IUser,
  PagedRequest,
  PagedResponse,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';
// import { User } from './users.types';

const usersApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<
      PagedResponse<IUser[]>,
      PagedRequest & { search?: string }
    >({
      query: (request) => ({
        url: 'users',
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'Users' as const,
                id: _id.toString(),
              })),
              { type: 'Users', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Users', id: 'PARTIAL-LIST' }],
    }),
    getUser: build.query<IUser, string>({
      query: (id) => ({
        url: `users/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Users' as const, id: result?._id.toString() },
      ],
    }),
    getCurrentUser: build.query<IUser, void>({
      query: () => ({
        url: `users/current`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Users' as const, id: result?._id.toString() },
      ],
    }),
    updateUser: build.mutation<
      IUser,
      { id: string; data: Partial<IEditingUser> }
    >({
      query: (request) => ({
        url: `users/${request.id}`,
        method: 'PUT',
        body: request.data,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Users', id: 'PARTIAL-LIST' },
        { type: 'Users', id: result?._id.toString() },
      ],
    }),
    createUser: build.mutation<IUser, Partial<IUser>>({
      query: (request) => ({
        url: `users`,
        method: 'POST',
        body: request,
      }),
      invalidatesTags: (result, error, product) => [
        { type: 'Users', id: 'PARTIAL-LIST' },
        { type: 'Users', id: result?._id.toString() },
      ],
    }),
  }),
});

export const {
  useGetUserQuery,
  useUpdateUserMutation,
  useGetUsersQuery,
  useGetCurrentUserQuery,
  useCreateUserMutation,
} = usersApi;
